import styled from 'styled-components'
import theme from '../../theme/theme';

export const MainContainer = styled.div`
display: flex;
flex-direction: column;
width: 90%;
margin: 0 auto;
justify-content: center;

`;

export const MainHeader = styled.h1`
font-size: 3rem;
font-weight: 700;
color: ${theme.color.navy};
margin: 40px 0 -30px 0;

@media (max-width: 640px) {
    font-size: 2.5rem;
}
`;

export const Container = styled.div` 
    margin: 0 4rem;
    @media (max-width: 400px) {
        margin: 0 7% 5% 7%;
    }
`;

export const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 30px 0 0.7rem 0;
`;

export const UserContainer = styled.div`
display: flex;
width: 100%;
justify-content: space-between;
`;

export const Span = styled.span`
font-size: 1.2rem;
font-weight: bold;
`;

export const Info = styled.p`
font-size: 1.2rem;
`;